import React, { useEffect, useRef, useState } from "react";
import {
  IoIosArrowForward,
  IoIosCheckmark,
  IoMdArrowRoundBack,
  IoMdArrowRoundForward,
} from "react-icons/io";
import Select from "react-select";
import {
  ChangeTitle,
  selectFormStyle,
  selectStyle,
  selectStyle3,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { Link, useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import Slider from "react-slick";
import { BiMinus } from "react-icons/bi";
import { BsPlusLg } from "react-icons/bs";
import { Disclosure } from "@headlessui/react";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import * as Yup from "yup";
import { useFormik } from "formik";
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer } from "react-toastify";
import { setCookie } from "../../helpers/CookieComponent";

const onlyIntRegExp = /^[0-9+]+$/;
const onlyAlphabet = /^[A-Za-z][A-Za-z\s]+$/;

// Formik InitialValues
const initialValuesConnect = {
  firstName: "",
  lastName: "",
  mobileNumber: "",
  emailId: "",
  pincode: "",
  productType: "",
  message: "",
};
const initialValuesContact = {
  contactNumber: "",
  emailId: "",
};

// Fromik Validation Schema
const schemaConnect = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required("First name is required")
    .matches(onlyAlphabet, "First name is not valid"),
  lastName: Yup.string()
    .trim()
    .required("Last name is required")
    .matches(onlyAlphabet, "Last name is not valid"),
  mobileNumber: Yup.string()
    .trim()
    .required("Mobile number is required")
    .matches(onlyIntRegExp, "Mobile number is not valid")
    .min(10, "Mobile number is not valid")
    .max(16, "Mobile number is not valid"),
  emailId: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
  pincode: Yup.string()
    .trim()
    .required("Pin code is required")
    .matches(onlyIntRegExp, "Pin code is not valid"),
  productType: Yup.string().trim().required("Select product type"),
  message: Yup.string().trim().required("Message is required"),
});
const schemaContact = Yup.object().shape({
  contactNumber: Yup.string()
    .trim()
    .required("Contact number is required")
    .matches(onlyIntRegExp, "Contact number is not valid")
    .min(10, "Contact number is not valid")
    .max(16, "Contact number is not valid"),
  emailId: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
});

const ReadyReferenceTwo = () => {
  ChangeTitle("ReadyReference");
  const [mainMenu, setMainMenu] = useState("Combo");
  const [selectedMenu, setSelectedMenu] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("INR");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [currencyList, setCurrencyList] = useState([
    {
      id: "67658011a986de15483a4d8d",
      value: "BHD",
      label: "Bahraini dinar (.د.ب) - BHD",
      currencySymbol: ".د.ب",
      currency: "BHD",
    },
    {
      id: "67657feea986de15483a4d8b",
      value: "QAR",
      label: "Qatari riyal (ق.ر) - QAR",
      currencySymbol: "ق.ر",
      currency: "QAR",
    },
    {
      id: "67657fbaa986de15483a4d89",
      value: "OMR",
      label: "Omani rial (.ع.ر) - OMR",
      currencySymbol: ".ع.ر",
      currency: "OMR",
    },
    {
      id: "67657f8ea986de15483a4d87",
      value: "AED",
      label: "United Arab Emirates dirham (إ.د) - AED",
      currencySymbol: "إ.د",
      currency: "AED",
    },
    {
      id: "67657f44a986de15483a4d85",
      value: "USD",
      label: "United States dollar ($) - USD",
      currencySymbol: "$",
      currency: "USD",
    },
    {
      id: "6766b1d233388134035e739c",
      value: "INR",
      label: "Indian rupee (₹) - INR",
      currencySymbol: "₹",
      currency: "INR",
    },
  ]);
  const [countryList, setCountryList] = useState(
    [
      {
          "value": 250,
          "label": "Sint Maarten (Dutch part)"
      },
      {
          "value": 241,
          "label": "Virgin Islands (British)"
      },
      {
          "value": 242,
          "label": "Virgin Islands (US)"
      },
      {
          "value": 243,
          "label": "Wallis And Futuna Islands"
      },
      {
          "value": 244,
          "label": "Western Sahara"
      },
      {
          "value": 245,
          "label": "Yemen"
      },
      {
          "value": 246,
          "label": "Zambia"
      },
      {
          "value": 247,
          "label": "Zimbabwe"
      },
      {
          "value": 248,
          "label": "Kosovo"
      },
      {
          "value": 249,
          "label": "Curaçao"
      },
      {
          "value": 221,
          "label": "Tokelau"
      },
      {
          "value": 222,
          "label": "Tonga"
      },
      {
          "value": 223,
          "label": "Trinidad And Tobago"
      },
      {
          "value": 224,
          "label": "Tunisia"
      },
      {
          "value": 225,
          "label": "Turkey"
      },
      {
          "value": 226,
          "label": "Turkmenistan"
      },
      {
          "value": 227,
          "label": "Turks And Caicos Islands"
      },
      {
          "value": 228,
          "label": "Tuvalu"
      },
      {
          "value": 229,
          "label": "Uganda"
      },
      {
          "value": 230,
          "label": "Ukraine"
      },
      {
          "value": 231,
          "label": "United Arab Emirates"
      },
      {
          "value": 232,
          "label": "United Kingdom"
      },
      {
          "value": 233,
          "label": "United States"
      },
      {
          "value": 234,
          "label": "United States Minor Outlying Islands"
      },
      {
          "value": 235,
          "label": "Uruguay"
      },
      {
          "value": 236,
          "label": "Uzbekistan"
      },
      {
          "value": 237,
          "label": "Vanuatu"
      },
      {
          "value": 238,
          "label": "Vatican City State (Holy See)"
      },
      {
          "value": 239,
          "label": "Venezuela"
      },
      {
          "value": 240,
          "label": "Vietnam"
      },
      {
          "value": 202,
          "label": "Solomon Islands"
      },
      {
          "value": 203,
          "label": "Somalia"
      },
      {
          "value": 204,
          "label": "South Africa"
      },
      {
          "value": 205,
          "label": "South Georgia"
      },
      {
          "value": 206,
          "label": "South Sudan"
      },
      {
          "value": 207,
          "label": "Spain"
      },
      {
          "value": 208,
          "label": "Sri Lanka"
      },
      {
          "value": 209,
          "label": "Sudan"
      },
      {
          "value": 210,
          "label": "Suriname"
      },
      {
          "value": 211,
          "label": "Svalbard And Jan Mayen Islands"
      },
      {
          "value": 212,
          "label": "Swaziland"
      },
      {
          "value": 213,
          "label": "Sweden"
      },
      {
          "value": 214,
          "label": "Switzerland"
      },
      {
          "value": 215,
          "label": "Syria"
      },
      {
          "value": 216,
          "label": "Taiwan"
      },
      {
          "value": 217,
          "label": "Tajikistan"
      },
      {
          "value": 218,
          "label": "Tanzania"
      },
      {
          "value": 219,
          "label": "Thailand"
      },
      {
          "value": 220,
          "label": "Togo"
      },
      {
          "value": 194,
          "label": "Saudi Arabia"
      },
      {
          "value": 195,
          "label": "Senegal"
      },
      {
          "value": 196,
          "label": "Serbia"
      },
      {
          "value": 197,
          "label": "Seychelles"
      },
      {
          "value": 198,
          "label": "Sierra Leone"
      },
      {
          "value": 199,
          "label": "Singapore"
      },
      {
          "value": 200,
          "label": "Slovakia"
      },
      {
          "value": 201,
          "label": "Slovenia"
      },
      {
          "value": 176,
          "label": "Poland"
      },
      {
          "value": 177,
          "label": "Portugal"
      },
      {
          "value": 178,
          "label": "Puerto Rico"
      },
      {
          "value": 179,
          "label": "Qatar"
      },
      {
          "value": 180,
          "label": "Reunion"
      },
      {
          "value": 181,
          "label": "Romania"
      },
      {
          "value": 182,
          "label": "Russia"
      },
      {
          "value": 183,
          "label": "Rwanda"
      },
      {
          "value": 184,
          "label": "Saint Helena"
      },
      {
          "value": 185,
          "label": "Saint Kitts And Nevis"
      },
      {
          "value": 186,
          "label": "Saint Lucia"
      },
      {
          "value": 187,
          "label": "Saint Pierre and Miquelon"
      },
      {
          "value": 188,
          "label": "Saint Vincent And The Grenadines"
      },
      {
          "value": 189,
          "label": "Saint-Barthelemy"
      },
      {
          "value": 190,
          "label": "Saint-Martin (French part)"
      },
      {
          "value": 191,
          "label": "Samoa"
      },
      {
          "value": 192,
          "label": "San Marino"
      },
      {
          "value": 193,
          "label": "Sao Tome and Principe"
      },
      {
          "value": 154,
          "label": "Nepal"
      },
      {
          "value": 155,
          "label": "Bonaire, Sint Eustatius and Saba"
      },
      {
          "value": 156,
          "label": "Netherlands"
      },
      {
          "value": 157,
          "label": "New Caledonia"
      },
      {
          "value": 158,
          "label": "New Zealand"
      },
      {
          "value": 159,
          "label": "Nicaragua"
      },
      {
          "value": 160,
          "label": "Niger"
      },
      {
          "value": 161,
          "label": "Nigeria"
      },
      {
          "value": 162,
          "label": "Niue"
      },
      {
          "value": 163,
          "label": "Norfolk Island"
      },
      {
          "value": 164,
          "label": "Northern Mariana Islands"
      },
      {
          "value": 165,
          "label": "Norway"
      },
      {
          "value": 166,
          "label": "Oman"
      },
      {
          "value": 167,
          "label": "Pakistan"
      },
      {
          "value": 168,
          "label": "Palau"
      },
      {
          "value": 169,
          "label": "Palestinian Territory Occupied"
      },
      {
          "value": 170,
          "label": "Panama"
      },
      {
          "value": 171,
          "label": "Papua new Guinea"
      },
      {
          "value": 172,
          "label": "Paraguay"
      },
      {
          "value": 173,
          "label": "Peru"
      },
      {
          "value": 174,
          "label": "Philippines"
      },
      {
          "value": 175,
          "label": "Pitcairn Island"
      },
      {
          "value": 132,
          "label": "Malaysia"
      },
      {
          "value": 133,
          "label": "Maldives"
      },
      {
          "value": 134,
          "label": "Mali"
      },
      {
          "value": 135,
          "label": "Malta"
      },
      {
          "value": 136,
          "label": "Man (Isle of)"
      },
      {
          "value": 137,
          "label": "Marshall Islands"
      },
      {
          "value": 138,
          "label": "Martinique"
      },
      {
          "value": 139,
          "label": "Mauritania"
      },
      {
          "value": 140,
          "label": "Mauritius"
      },
      {
          "value": 141,
          "label": "Mayotte"
      },
      {
          "value": 142,
          "label": "Mexico"
      },
      {
          "value": 143,
          "label": "Micronesia"
      },
      {
          "value": 144,
          "label": "Moldova"
      },
      {
          "value": 145,
          "label": "Monaco"
      },
      {
          "value": 146,
          "label": "Mongolia"
      },
      {
          "value": 147,
          "label": "Montenegro"
      },
      {
          "value": 148,
          "label": "Montserrat"
      },
      {
          "value": 149,
          "label": "Morocco"
      },
      {
          "value": 150,
          "label": "Mozambique"
      },
      {
          "value": 151,
          "label": "Myanmar"
      },
      {
          "value": 152,
          "label": "Namibia"
      },
      {
          "value": 153,
          "label": "Nauru"
      },
      {
          "value": 111,
          "label": "Jordan"
      },
      {
          "value": 112,
          "label": "Kazakhstan"
      },
      {
          "value": 113,
          "label": "Kenya"
      },
      {
          "value": 114,
          "label": "Kiribati"
      },
      {
          "value": 115,
          "label": "North Korea"
      },
      {
          "value": 116,
          "label": "South Korea"
      },
      {
          "value": 117,
          "label": "Kuwait"
      },
      {
          "value": 118,
          "label": "Kyrgyzstan"
      },
      {
          "value": 119,
          "label": "Laos"
      },
      {
          "value": 120,
          "label": "Latvia"
      },
      {
          "value": 121,
          "label": "Lebanon"
      },
      {
          "value": 122,
          "label": "Lesotho"
      },
      {
          "value": 123,
          "label": "Liberia"
      },
      {
          "value": 124,
          "label": "Libya"
      },
      {
          "value": 125,
          "label": "Liechtenstein"
      },
      {
          "value": 126,
          "label": "Lithuania"
      },
      {
          "value": 127,
          "label": "Luxembourg"
      },
      {
          "value": 128,
          "label": "Macau S.A.R."
      },
      {
          "value": 129,
          "label": "Macedonia"
      },
      {
          "value": 130,
          "label": "Madagascar"
      },
      {
          "value": 131,
          "label": "Malawi"
      },
      {
          "value": 91,
          "label": "Guernsey and Alderney"
      },
      {
          "value": 92,
          "label": "Guinea"
      },
      {
          "value": 93,
          "label": "Guinea-Bissau"
      },
      {
          "value": 94,
          "label": "Guyana"
      },
      {
          "value": 95,
          "label": "Haiti"
      },
      {
          "value": 96,
          "label": "Heard Island and McDonald Islands"
      },
      {
          "value": 97,
          "label": "Honduras"
      },
      {
          "value": 98,
          "label": "Hong Kong S.A.R."
      },
      {
          "value": 99,
          "label": "Hungary"
      },
      {
          "value": 100,
          "label": "Iceland"
      },
      {
          "value": 101,
          "label": "India"
      },
      {
          "value": 102,
          "label": "Indonesia"
      },
      {
          "value": 103,
          "label": "Iran"
      },
      {
          "value": 104,
          "label": "Iraq"
      },
      {
          "value": 105,
          "label": "Ireland"
      },
      {
          "value": 106,
          "label": "Israel"
      },
      {
          "value": 107,
          "label": "Italy"
      },
      {
          "value": 108,
          "label": "Jamaica"
      },
      {
          "value": 109,
          "label": "Japan"
      },
      {
          "value": 110,
          "label": "Jersey"
      },
      {
          "value": 70,
          "label": "Ethiopia"
      },
      {
          "value": 71,
          "label": "Falkland Islands"
      },
      {
          "value": 72,
          "label": "Faroe Islands"
      },
      {
          "value": 73,
          "label": "Fiji Islands"
      },
      {
          "value": 74,
          "label": "Finland"
      },
      {
          "value": 75,
          "label": "France"
      },
      {
          "value": 76,
          "label": "French Guiana"
      },
      {
          "value": 77,
          "label": "French Polynesia"
      },
      {
          "value": 78,
          "label": "French Southern Territories"
      },
      {
          "value": 79,
          "label": "Gabon"
      },
      {
          "value": 80,
          "label": "Gambia The"
      },
      {
          "value": 81,
          "label": "Georgia"
      },
      {
          "value": 82,
          "label": "Germany"
      },
      {
          "value": 83,
          "label": "Ghana"
      },
      {
          "value": 84,
          "label": "Gibraltar"
      },
      {
          "value": 85,
          "label": "Greece"
      },
      {
          "value": 86,
          "label": "Greenland"
      },
      {
          "value": 87,
          "label": "Grenada"
      },
      {
          "value": 88,
          "label": "Guadeloupe"
      },
      {
          "value": 89,
          "label": "Guam"
      },
      {
          "value": 90,
          "label": "Guatemala"
      },
      {
          "value": 55,
          "label": "Croatia"
      },
      {
          "value": 56,
          "label": "Cuba"
      },
      {
          "value": 57,
          "label": "Cyprus"
      },
      {
          "value": 58,
          "label": "Czech Republic"
      },
      {
          "value": 59,
          "label": "Denmark"
      },
      {
          "value": 60,
          "label": "Djibouti"
      },
      {
          "value": 61,
          "label": "Dominica"
      },
      {
          "value": 62,
          "label": "Dominican Republic"
      },
      {
          "value": 63,
          "label": "East Timor"
      },
      {
          "value": 64,
          "label": "Ecuador"
      },
      {
          "value": 65,
          "label": "Egypt"
      },
      {
          "value": 66,
          "label": "El Salvador"
      },
      {
          "value": 67,
          "label": "Equatorial Guinea"
      },
      {
          "value": 68,
          "label": "Eritrea"
      },
      {
          "value": 69,
          "label": "Estonia"
      },
      {
          "value": 35,
          "label": "Burkina Faso"
      },
      {
          "value": 36,
          "label": "Burundi"
      },
      {
          "value": 37,
          "label": "Cambodia"
      },
      {
          "value": 38,
          "label": "Cameroon"
      },
      {
          "value": 39,
          "label": "Canada"
      },
      {
          "value": 40,
          "label": "Cape Verde"
      },
      {
          "value": 41,
          "label": "Cayman Islands"
      },
      {
          "value": 42,
          "label": "Central African Republic"
      },
      {
          "value": 43,
          "label": "Chad"
      },
      {
          "value": 44,
          "label": "Chile"
      },
      {
          "value": 45,
          "label": "China"
      },
      {
          "value": 46,
          "label": "Christmas Island"
      },
      {
          "value": 47,
          "label": "Cocos (Keeling) Islands"
      },
      {
          "value": 48,
          "label": "Colombia"
      },
      {
          "value": 49,
          "label": "Comoros"
      },
      {
          "value": 50,
          "label": "Congo"
      },
      {
          "value": 51,
          "label": "Democratic Republic of the Congo"
      },
      {
          "value": 52,
          "label": "Cook Islands"
      },
      {
          "value": 53,
          "label": "Costa Rica"
      },
      {
          "value": 54,
          "label": "Cote D'Ivoire (Ivory Coast)"
      },
      {
          "value": 22,
          "label": "Belgium"
      },
      {
          "value": 23,
          "label": "Belize"
      },
      {
          "value": 24,
          "label": "Benin"
      },
      {
          "value": 25,
          "label": "Bermuda"
      },
      {
          "value": 26,
          "label": "Bhutan"
      },
      {
          "value": 27,
          "label": "Bolivia"
      },
      {
          "value": 28,
          "label": "Bosnia and Herzegovina"
      },
      {
          "value": 29,
          "label": "Botswana"
      },
      {
          "value": 30,
          "label": "Bouvet Island"
      },
      {
          "value": 31,
          "label": "Brazil"
      },
      {
          "value": 32,
          "label": "British Indian Ocean Territory"
      },
      {
          "value": 33,
          "label": "Brunei"
      },
      {
          "value": 34,
          "label": "Bulgaria"
      },
      {
          "value": 13,
          "label": "Aruba"
      },
      {
          "value": 14,
          "label": "Australia"
      },
      {
          "value": 15,
          "label": "Austria"
      },
      {
          "value": 16,
          "label": "Azerbaijan"
      },
      {
          "value": 17,
          "label": "The Bahamas"
      },
      {
          "value": 18,
          "label": "Bahrain"
      },
      {
          "value": 19,
          "label": "Bangladesh"
      },
      {
          "value": 20,
          "label": "Barbados"
      },
      {
          "value": 21,
          "label": "Belarus"
      },
      {
          "value": 9,
          "label": "Antarctica"
      },
      {
          "value": 10,
          "label": "Antigua And Barbuda"
      },
      {
          "value": 11,
          "label": "Argentina"
      },
      {
          "value": 12,
          "label": "Armenia"
      },
      {
          "value": 4,
          "label": "Algeria"
      },
      {
          "value": 5,
          "label": "American Samoa"
      },
      {
          "value": 6,
          "label": "Andorra"
      },
      {
          "value": 7,
          "label": "Angola"
      },
      {
          "value": 8,
          "label": "Anguilla"
      },
      {
          "value": 2,
          "label": "Aland Islands"
      },
      {
          "value": 3,
          "label": "Albania"
      },
      {
          "value": 1,
          "label": "Afghanistan"
      }

  ]);
  const [filterPlanList, setFilterPlanList] = useState([
    {
      id: "679711aba2a0f1792c7ad587",
      price: "80000.00",
      currency: "INR",
      name: "Combo 4",
      services: [
        {
          serviceId: "679710c8a2a0f1792c7ad50f",
          serviceName: "Excise",
        },
        {
          serviceId: "679710bea2a0f1792c7ad503",
          serviceName: "Stamp Economic  Substance Regulation",
        },
        {
          serviceId: "679710b3a2a0f1792c7ad4ef",
          serviceName: "Customs Stamp",
        },
        {
          serviceId: "679710a9a2a0f1792c7ad4df",
          serviceName: "Excise Customs",
        },
        {
          serviceId: "679710a0a2a0f1792c7ad4d3",
          serviceName: "Corporate Tax",
        },
        {
          serviceId: "67971094a2a0f1792c7ad4be",
          serviceName: "Value Added Tax (VAT)",
        },
        {
          serviceId: "679710d1a2a0f1792c7ad51b",
          serviceName: "International Taxation",
        },
      ],
      type: "Combo",
    },
    {
      id: "67971184a2a0f1792c7ad581",
      price: "40.00",
      currency: "INR",
      name: "Combo 3",
      services: [
        {
          serviceId: "679710c8a2a0f1792c7ad50f",
          serviceName: "Excise",
        },
        {
          serviceId: "679710bea2a0f1792c7ad503",
          serviceName: "Stamp Economic  Substance Regulation",
        },
        {
          serviceId: "679710b3a2a0f1792c7ad4ef",
          serviceName: "Customs Stamp",
        },
        {
          serviceId: "679710a9a2a0f1792c7ad4df",
          serviceName: "Excise Customs",
        },
        {
          serviceId: "679710a0a2a0f1792c7ad4d3",
          serviceName: "Corporate Tax",
        },
        {
          serviceId: "67971094a2a0f1792c7ad4be",
          serviceName: "Value Added Tax (VAT)",
        },
        {
          serviceId: "679710d1a2a0f1792c7ad51b",
          serviceName: "International Taxation",
        },
      ],
      type: "Combo",
    },
    {
      id: "67971151a2a0f1792c7ad56b",
      price: "30.00",
      currency: "INR",
      name: "Combo 2",
      services: [
        {
          serviceId: "679710bea2a0f1792c7ad503",
          serviceName: "Stamp Economic  Substance Regulation",
        },
        {
          serviceId: "679710b3a2a0f1792c7ad4ef",
          serviceName: "Customs Stamp",
        },
        {
          serviceId: "679710a9a2a0f1792c7ad4df",
          serviceName: "Excise Customs",
        },
        {
          serviceId: "679710a0a2a0f1792c7ad4d3",
          serviceName: "Corporate Tax",
        },
        {
          serviceId: "67971094a2a0f1792c7ad4be",
          serviceName: "Value Added Tax (VAT)",
        },
        {
          serviceId: "679710c8a2a0f1792c7ad50f",
          serviceName: "Excise",
        },
      ],
      type: "Combo",
    },
    {
      id: "67971121a2a0f1792c7ad55b",
      price: "25.00",
      currency: "INR",
      name: "Combo 1",
      services: [
        {
          serviceId: "67971094a2a0f1792c7ad4be",
          serviceName: "Value Added Tax (VAT)",
        },
        {
          serviceId: "679710a0a2a0f1792c7ad4d3",
          serviceName: "Corporate Tax",
        },
      ],
      type: "Combo",
    },
  ]);
  const [filterPlanList2, setFilterPlanList2] = useState([
    {
      id: "678f4e2a986040c23401d1bd",
      price: "20000.00",
      currency: "INR",
      name: "GCC Law",
      type: "Individual",
      taxservice: "Value added Tax & International Taxation",
    },
    {
      id: "678f4e33986040c23401d1c5",
      price: "43553.00",
      currency: "INR",
      name: "GCC Law",
      type: "Individual",
      taxservice: "Law Description",
    },
    {
      id: "678f4e3d986040c23401d1cd",
      price: "53455.00",
      currency: "INR",
      name: "GCC Law",
      type: "Individual",
      taxservice: "Law Description",
    },
    {
      id: "678f4e46986040c23401d1d5",
      price: "73432.00",
      currency: "INR",
      name: "GCC Law",
      type: "Individual",
      taxservice: "Excise Tax Services",
    },
    {
      id: "6793412da4e74ee1a2689c3e",
      price: "250.00",
      currency: "INR",
      name: "test ten",
      type: "Individual",
      taxservice: "Law Description",
    },
    {
      id: "679341d8a4e74ee1a2689d11",
      price: "2000.00",
      currency: "INR",
      name: "test ten",
      type: "Individual",
      taxservice: "Law Description",
    },
    {
      id: "67934437929a1533ba116716",
      price: "2000.00",
      currency: "INR",
      name: "test ten ONE",
      type: "Individual",
      taxservice: "Law Description",
    },
  ]);
  const [filterPlanList3, setFilterPlanList3] = useState([
    {
      id: "679710cea2a0f1792c7ad517",
      price: "500.00",
      currency: "INR",
      name: "",
      type: "Country Wise",
      country: "Ukraine",
    },
    {
      id: "679710c5a2a0f1792c7ad509",
      price: "10000.00",
      currency: "INR",
      name: "",
      type: "Country Wise",
      country: "India",
    },
    {
      id: "679710baa2a0f1792c7ad4fb",
      price: "8000.00",
      currency: "INR",
      name: "",
      type: "Country Wise",
      country: "Tuvalu",
    },
    {
      id: "679710b3a2a0f1792c7ad4ed",
      price: "5000.00",
      currency: "INR",
      name: "",
      type: "Country Wise",
      country: "India",
    },
    {
      id: "679710aba2a0f1792c7ad4e3",
      price: "3000.00",
      currency: "INR",
      name: "",
      type: "Country Wise",
      country: "Ukraine",
    },
  ]);
  const [loadingConnect, setLoadingConnect] = useState(false);
  const [loadingContact, setLoadingContact] = useState(false);
  const [productTypeList, setProductTypeList] = useState([
    {
      value: "677628e0e054393ab1dc2f91",
      label: "Product Type 2",
    },
    {
      value: "677628dae054393ab1dc2f8e",
      label: "Product Type 1",
    },
  ]);
  const [faqsList, setFaqsList] = useState([
    {
      id: "67541354474475665b240bfc",
      question: "How do I subscribe to GCC Law Help?",
      answer: "<ul><li>You can subscribe by clicking [here]</li><br></ul>",
    },
    {
      id: "675413a8474475665b240c0a",
      question: "How many users can access it at a time?",
      answer:
        "<ul><li>Only a single user can access it per single license.</li><br></ul>",
    },
    {
      id: "675413c0474475665b240c10",
      question: "Do you have multi-user access?",
      answer:
        "<ul><li>Yes, multi-user access is available. For details, contact Support.</li><br></ul>",
    },
    {
      id: "675413d8474475665b240c16",
      question: "What is the validity of a subscription to GCC Law Help?",
      answer:
        "<ul><li>The subscription is valid for 365 days from the date of activation.</li><br></ul>",
    },
    {
      id: "6754143a474475665b240c1c",
      question: "How often is the website updated?",
      answer: "<p>The website is updated in real time</p>",
    },
  ]);
  const navigate = useNavigate();

  console.log("faqsList", faqsList);

  const [openIndex, setOpenIndex] = useState(null); // State to track which accordion is open

  // Accordion open verify function
  const isOpen = (index) => openIndex === index;

  // Accordion toggle function
  const toggleAccordion = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? -1 : index)); // Toggle or close the accordion
  };

  const formikConnect = useFormik({
    initialValues: initialValuesConnect,
    validationSchema: schemaConnect,
    onSubmit: async (values, { resetForm }) => {
      setLoadingConnect(true);

      const param = {
        firstName: values.firstName,
        lastName: values.lastName,
        mobileNumber: values.mobileNumber,
        email: values.emailId,
        pincode: values.pincode,
        productTypeId: values.productType,
        message: values.message,
      };

      const response = await postData(
        "readyrefernceconnect/add/detail",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoadingConnect(false);
          resetForm();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoadingConnect(false);
      }
    },
  });

  const formikContact = useFormik({
    initialValues: initialValuesContact,
    validationSchema: schemaContact,
    onSubmit: async (values, { resetForm }) => {
      setLoadingContact(true);

      const param = {
        contactNumber: values.contactNumber,
        email: values.emailId,
      };

      const response = await postData(
        "enterpricedetail/add/detail",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          closeModal();
          setLoadingContact(false);
          resetForm();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoadingContact(false);
      }
    },
  });

  const openModal = () => {
    document.body.style.overflowY = "hidden";
    setIsModalOpen(true);
  };
  const closeModal = () => {
    document.body.style.overflowY = "";
    setIsModalOpen(false);
    formikContact.resetForm();
  };

  // Product Type List API Call
  // const viewProductTypeList = async () => {
  //   const param = {};
  //   var response = await postData("producttype/list", param, apiHeader(false));

  //   if (
  //     String(response?.status) == "200" &&
  //     String(response?.data.status) == "200"
  //   ) {
  //     const data = response.data.data.list;
  //     const listData = data.map((data) => {
  //       return {
  //         value: data._id,
  //         label: data.productTypeName,
  //       };
  //     });
  //     setProductTypeList(listData);
  //   } else {
  //     console.log(response.data);
  //     console.log(response.data.message);
  //   }
  // };

  // // Currency API Call
  // const viewCurrencyList = async () => {
  //   const param = {};
  //   // var response = await postData("country/list", param, apiHeader(false));
  //   var response = await postData("currency/list", param, apiHeader(false));

  //   if (
  //     String(response?.status) == "200" &&
  //     String(response?.data.status) == "200"
  //   ) {
  //     const data = response.data.data.list;
  //     const currencyData = data.map((data) => {
  //       return {
  //         id: data._id,
  //         value: data.countryDetail.currency,
  //         label: `${data.countryDetail.currencyName} (${data.countryDetail.currencySymbol}) - ${data.countryDetail.currency}`,
  //         currencySymbol: data.countryDetail.currencySymbol,
  //         currency: data.countryDetail.currency,
  //       };
  //     });
  //     setCurrencyList(currencyData);
  //   } else {
  //     console.log(response.data);
  //     console.log(response.data.message);
  //   }
  // };

  // Faqs API Call
  // const viewFaqsList = async () => {
  //   const param = {
  //     type: "readyReference",
  //   };
  //   var response = await postData("faq/list", param, apiHeader(false));

  //   if (
  //     String(response?.status) == "200" &&
  //     String(response?.data.status) == "200"
  //   ) {
  //     const data = response.data.data.list;
  //     const faqsData = data.map((data) => {
  //       return {
  //         id: data._id,
  //         question: data.question,
  //         answer: data.answer,
  //       };
  //     });
  //     setFaqsList(faqsData);
  //   } else {
  //     console.log(response.data);
  //     console.log(response.data.message);
  //   }
  // };

  useEffect(() => {
    // viewFaqsList();
    // viewCurrencyList();
    // viewProductTypeList();
    // setCookie("rr-plan-currency", "INR", {});
  }, []);

  // Plans API Call
  // const viewFilterPlanList = async (type, currency) => {
  //   const param = {
  //     type: String(type),
  //     currency: currency,
  //   };

  //   var response = await postData(
  //     "readyreferenceplan/user/list",
  //     param,
  //     apiHeader(false)
  //   );

  //   if (
  //     String(response?.status) == "200" &&
  //     String(response?.data.status) == "200"
  //   ) {
  //     const data = response.data.data.list;
  //     const filterPlanListData = data.map((data) => {
  //       return {
  //         id: data._id,
  //         price: data.price.toFixed(2),
  //         currency: data.defaultCurrency,
  //         name: data.name,
  //         description: data.description,
  //         services: data.services,
  //         type: data.type,
  //         planTypeName: data.planTypeName,
  //         taxservice: data.taxservice && data.taxservice.serviceName,
  //         country: data.country && data.country.countryName,
  //       };
  //     });
  //     setFilterPlanList(filterPlanListData);
  //   } else {
  //     console.log(response.data);
  //     console.log(response.data.message);
  //   }
  // };

  // useEffect(() => {
  //   viewFilterPlanList(mainMenu, selectedCurrency);
  // }, [mainMenu, selectedCurrency]);

  // Plan Buy Function
  const buyPlan = async (data, type) => {
    // setCookie("rr-planbillingId", data.id, {});
    // setCookie("rr-plan-type", type, {});
    navigate("/readyreference/billing2");

    // const param = {
    //   planId: data.id,
    //   type: type,
    //   promoCode: "",
    //   currency: data.currency || "INR",
    // };
    // var response = await postData(
    //   "private/readyreferenceplanpurchase/preview",
    //   param,
    //   apiHeader(false)
    // );

    // console.log("rr plan detail billing", response);

    // if (
    //   String(response?.status) == "200" &&
    //   String(response?.data.status) == "200"
    // ) {
    // } else {
    //   toasterrormsg(response.data.message);
    // }
  };

  // Slider Setting
  const rrSetting2 = {
    slidesPerRow: 1,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: false,
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          // speed: 2000,
          // autoplay: true,
          // autoplaySpeed: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const rrSetting = {
    slidesPerRow: 1,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          // speed: 2000,
          // autoplay: true,
          // autoplaySpeed: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <ToastContainer />
      {isModalOpen === true && (
        <>
          <div
            onClick={closeModal}
            className="w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[5%] lg:my-0 relative lg:top-[15%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="flex items-center justify-between">
                <h1 className="mb-[3%] hanson">Get in touch</h1>
                <IoClose
                  onClick={closeModal}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formikContact.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Contact number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter contact number"
                        id="contactNumber"
                        value={formikContact.values.contactNumber}
                        onChange={formikContact.handleChange}
                      />
                      {formikContact.touched.contactNumber &&
                        formikContact.errors.contactNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikContact.errors.contactNumber}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email id
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter email id"
                        id="emailId"
                        value={formikContact.values.emailId}
                        onChange={formikContact.handleChange}
                      />
                      {formikContact.touched.emailId &&
                        formikContact.errors.emailId && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikContact.errors.emailId}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loadingContact}
                    >
                      {!loadingContact && <>Submit</>}
                      {loadingContact && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loadingContact}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="relative w-full h-auto px-[5%] py-[5%] lg:py-[2%] bg-light-yellow">
        <div className="xxl:container mx-auto">
          <div className="mb-[3rem]">
            <h1 className="mb-[1rem] rrd-title">
              Ready referencer is a comprehensive platform for GCC tax law
              research. Here’s a simple breakdown of its features:
            </h1>
            <ul className="pl-[3rem] lg:pl-[5rem] rrd-ul">
              <li className="rrd-ul-li">
                Powerful search engine -{" "}
                <span className="rrd-ul-li-span">
                  Helps you find information quickly and efficiently.
                </span>
              </li>
              <li className="rrd-ul-li">
                Smart integration -{" "}
                <span className="rrd-ul-li-span">
                  Seamlessly connects different tools and resources.
                </span>
              </li>
              <li className="rrd-ul-li">
                Always-amended statutes -{" "}
                <span className="rrd-ul-li-span">
                  Ensures you have access to the most current laws.
                </span>
              </li>
            </ul>
          </div>
          <div className="w-[90%] mx-auto grid grid-cols-1 md:grid-cols-2 md:gap-20 mb-[-2%]">
            <div className="flex relative z-[3] mb-[2rem] justify-center items-center gap-5">
              <label className="w-max currencylabel">Currency</label>
              <div className="w-[80%] currencyselect">
                <Select
                  name="currenyName"
                  id="currencyName"
                  placeholder="Select Currency"
                  className="w-full cs-main"
                  isSearchable={true}
                  options={currencyList}
                  value={currencyList.find(
                    (item) => item.value === selectedCurrency
                  )}
                  onChange={(e) => {
                    setSelectedCurrency(e.value);
                    setCurrencySymbol(e.currency);
                    setCookie("rr-plan-currency", e.currency, {});
                  }}
                  styles={{
                    ...selectStyle3,
                    menuPortal: (base) => ({ ...base, zIndex: 99 }),
                  }}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>
            <div className="flex relative z-[3] mb-[2rem] justify-center items-center gap-5">
              <label className="w-max currencylabel">Country</label>
              <div className="w-[80%] currencyselect">
                <Select
                  name="countryName"
                  id="countryName"
                  placeholder="Select Country"
                  className="w-full cs-main"
                  isSearchable={true}
                  options={countryList}
                  value={countryList.find(
                    (item) => item.value === selectedCountry
                  )}
                  onChange={(e) => {
                    setSelectedCountry(e.value);
                  }}
                  styles={{
                    ...selectStyle3,
                    menuPortal: (base) => ({ ...base, zIndex: 99 }),
                  }}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>
          </div>
          {/* <div className="flex relative z-[3] mb-[2rem] justify-center items-center gap-5">
            <label className="currencylabel">Currency</label>
            <div className="w-[60%] md:w-[30%] currencyselect">
              <Select
                name="countryName"
                id="country"
                placeholder="Select Country"
                className="w-full cs-main"
                isSearchable={true}
                options={currencyList}
                value={currencyList.find(
                  (item) => item.value === selectedCurrency
                )}
                onChange={(e) => {
                  setSelectedCurrency(e.value);
                  setCurrencySymbol(e.currency);
                  setCookie("rr-plan-currency", e.currency, {});
                }}
                styles={selectStyle}
              />
            </div>
          </div> */}
          <div className="relative z-[2] top-[3vw] w-full md:w-[80%] lg:w-[50%] flex justify-evenly py-[2%] mx-auto rr-main-menu">
            <Link
              className={
                mainMenu === "Combo" ? "rrmm-box-active rrmm-box" : "rrmm-box"
              }
              onClick={() => setMainMenu("Combo")}
            >
              Combo
            </Link>
            <Link
              className={
                mainMenu === "Individual"
                  ? "rrmm-box-active rrmm-box"
                  : "rrmm-box"
              }
              onClick={() => setMainMenu("Individual")}
            >
              Individual
            </Link>
            <Link
              className={
                mainMenu === "Country Wise"
                  ? "rrmm-box-active rrmm-box"
                  : "rrmm-box"
              }
              onClick={() => setMainMenu("Country Wise")}
            >
              Country wise
            </Link>
            <Link
              className={
                mainMenu === "Enterprise"
                  ? "rrmm-box-active rrmm-box"
                  : "rrmm-box"
              }
              onClick={() => setMainMenu("Enterprise")}
            >
              Enterprise
            </Link>
          </div>
          {mainMenu && mainMenu == "Combo" && (
            <div className="relative z-[1] mb-[5%] w-[90%] flex mx-auto px-[3%] pb-[5%] pt-[7%] rr-combo-box">
              <div className="w-full">
                {filterPlanList.length > 0 && (
                  <Slider
                    className="w-full mx-auto cursor-pointer flex gap-10 relative z-[1] hp1-part2-imgs rr-box"
                    {...rrSetting}
                  >
                    {filterPlanList.map((data) => (
                      <section className="relative z-[10] w-full h-full md:px-[10%] flex flex-col justify-between rrcb-main">
                        <section className="">
                          <h1 className="w-full text-center py-[5%] hanson">
                            {data.name}
                          </h1>
                          <h2 className="text-center py-[5%]  rrcbprice">
                            {selectedCurrency} {data.price}
                          </h2>
                          {data.services &&
                            data.services.map((data) => (
                              <section className="w-full mb-[8%] flex gap-5 rrcbpoint">
                                <IoIosCheckmark className="items-center rrcbtick" />
                                <h3 className="leading-none w-[80%]">
                                  {data.serviceName}
                                </h3>
                              </section>
                            ))}
                        </section>
                        <section className="w-full rrcb-btn">
                          <button
                            onClick={() => buyPlan(data, mainMenu)}
                            className="py-[5%] w-full btn-choose-plan"
                          >
                            Choose plan
                          </button>
                        </section>
                      </section>
                    ))}
                  </Slider>
                )}
                {filterPlanList.length == 0 && (
                  <>
                    <h1 className="text-center not-exist-msg">No data found</h1>
                  </>
                )}
              </div>
            </div>
          )}
          {mainMenu && mainMenu == "Individual" && (
            <div className="relative z-[1] mb-[5%] w-[90%] flex mx-auto px-[3%] pb-[5%] pt-[7%] rr-combo-box rr-individual-box">
              <div className="w-full">
                {filterPlanList2.length > 0 && (
                  <Slider
                    className="w-full mx-auto cursor-pointer flex gap-10 relative z-[1] hp1-part2-imgs rr-box"
                    {...rrSetting2}
                  >
                    {filterPlanList2.map((data) => (
                      <section className="w-full flex flex-col justify-between h-full  md:px-[10%] rrcb-main rrcwb-main">
                        <section className="">
                          <h2 className="text-center py-[5%] mb-[5%] rribprice">
                            {selectedCurrency} {data.price}
                          </h2>
                          <h3 className="mb-[10%] rribtitle">
                            {data.taxservice}
                          </h3>
                        </section>
                        <section className="w-full rrcb-btn">
                          <button
                            onClick={() => buyPlan(data, mainMenu)}
                            className="py-[5%] w-full btn-choose-plan"
                          >
                            Choose plan
                          </button>
                        </section>
                      </section>
                    ))}
                  </Slider>
                )}
                {filterPlanList.length == 0 && (
                  <>
                    <h1 className="text-center not-exist-msg">No data found</h1>
                  </>
                )}
              </div>
            </div>
          )}
          {mainMenu && mainMenu == "Country Wise" && (
            <div className="relative z-[1] mb-[5%] w-[90%] flex mx-auto px-[3%] pb-[5%] pt-[7%] rr-combo-box rr-individual-box rr-countrywise-box">
              <div className="w-full">
                {filterPlanList3.length > 0 && (
                  <Slider
                    className="w-full mx-auto cursor-pointer flex gap-10 relative z-[1] hp1-part2-imgs rr-box"
                    {...rrSetting}
                  >
                    {filterPlanList3.map((data) => (
                      <section className="w-full flex flex-col justify-between h-full md:px-[10%] rrcb-main rrcwb-main">
                        <section className="">
                          <h2 className="text-center py-[5%] mb-[5%] rribprice">
                            {selectedCurrency} {data.price}
                          </h2>
                          <h3 className="mb-[10%] text-center rribtitle">
                            {data.country}
                          </h3>
                        </section>
                        <section className="w-full rrcb-btn">
                          <button
                            onClick={() => buyPlan(data, mainMenu)}
                            className="py-[5%] w-full btn-choose-plan"
                          >
                            Choose plan
                          </button>
                        </section>
                      </section>
                    ))}
                  </Slider>
                )}
                {filterPlanList.length == 0 && (
                  <>
                    <h1 className="text-center not-exist-msg">No data found</h1>
                  </>
                )}
              </div>
            </div>
          )}
          {mainMenu && mainMenu == "Enterprise" && (
            <div className="relative z-[1] mb-[5%] w-[90%] flex mx-auto px-[3%] pb-[5%] pt-[7%] rr-combo-box rr-individual-box rr-countrywise-box rr-enterprise-box">
              <div className="md:w-[70%] mx-auto">
                <h1 className="text-center mb-[5%] rreb-title">
                  For enterprises solutions, please submit your contact number
                  and email id so that our sales team can connect with you.
                </h1>
                <div className="w-full flex justify-center rrcb-btn">
                  <button
                    onClick={() => openModal()}
                    className="mx-auto py-[2%] w-[50%] md:w-[30%] btn-choose-plan"
                  >
                    Contact us
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="md:w-[90%] p-[3%] mb-[5%] mx-auto rr-form">
            <div className="flex items-center justify-between">
              <h1 className="mb-[3%] rr-form-h1 hanson">Let us connect</h1>
            </div>
            <form action="" onSubmit={formikConnect.handleSubmit}>
              <div className="w-full grid lg:grid-cols-2 gap-[2rem] mb-[4rem]">
                <div className="w-full flex flex-col">
                  <label
                    htmlFor=""
                    className="w-full form-input-label required mb-4"
                  >
                    First name
                  </label>
                  <input
                    className="w-full form-input"
                    type="text"
                    placeholder="Enter first name"
                    id="firstName"
                    value={formikConnect.values.firstName}
                    onChange={formikConnect.handleChange}
                  />
                  {formikConnect.touched.firstName &&
                    formikConnect.errors.firstName && (
                      <div className="mt-4 error-msg">
                        <div className="">{formikConnect.errors.firstName}</div>
                      </div>
                    )}
                </div>
                <div className="w-full flex flex-col">
                  <label
                    htmlFor=""
                    className="w-full form-input-label required mb-4"
                  >
                    Last name
                  </label>
                  <input
                    className="w-full form-input"
                    type="text"
                    placeholder="Enter last name"
                    id="lastName"
                    value={formikConnect.values.lastName}
                    onChange={formikConnect.handleChange}
                  />
                  {formikConnect.touched.lastName &&
                    formikConnect.errors.lastName && (
                      <div className="mt-4 error-msg">
                        <div className="">{formikConnect.errors.lastName}</div>
                      </div>
                    )}
                </div>{" "}
                <div className="w-full flex flex-col">
                  <label
                    htmlFor=""
                    className="w-full form-input-label required mb-4"
                  >
                    Mobile number
                  </label>
                  <input
                    className="w-full form-input"
                    type="text"
                    placeholder="Enter mobile number"
                    id="mobileNumber"
                    value={formikConnect.values.mobileNumber}
                    onChange={formikConnect.handleChange}
                  />
                  {formikConnect.touched.mobileNumber &&
                    formikConnect.errors.mobileNumber && (
                      <div className="mt-2 error-msg">
                        <div className="">
                          {formikConnect.errors.mobileNumber}
                        </div>
                      </div>
                    )}
                </div>
                <div className="w-full flex flex-col">
                  <label
                    htmlFor=""
                    className="w-full form-input-label required mb-4"
                  >
                    Email id
                  </label>
                  <input
                    className="w-full form-input"
                    type="email"
                    placeholder="Enter email id"
                    id="emailId"
                    value={formikConnect.values.emailId}
                    onChange={formikConnect.handleChange}
                  />
                  {formikConnect.touched.emailId &&
                    formikConnect.errors.emailId && (
                      <div className="mt-2 error-msg">
                        <div className="">{formikConnect.errors.emailId}</div>
                      </div>
                    )}
                </div>
                <div className="w-full flex flex-col">
                  <label
                    htmlFor=""
                    className="w-full form-input-label required mb-4"
                  >
                    Pin code
                  </label>
                  <input
                    className="w-full form-input"
                    type="text"
                    placeholder="Enter pin code"
                    id="pincode"
                    value={formikConnect.values.pincode}
                    onChange={formikConnect.handleChange}
                  />
                  {formikConnect.touched.pincode &&
                    formikConnect.errors.pincode && (
                      <div className="mt-2 error-msg">
                        <div className="">{formikConnect.errors.pincode}</div>
                      </div>
                    )}
                </div>
                <div className="w-full flex flex-col">
                  <label
                    htmlFor=""
                    className="w-full form-input-label required mb-4"
                  >
                    Product type
                  </label>
                  <Select
                    name="productType"
                    id="productType"
                    placeholder="Select product type"
                    className="w-full form-select form-input"
                    isSearchable={true}
                    options={productTypeList}
                    value={
                      formikConnect.values.productType &&
                      productTypeList.find(
                        (item) =>
                          item.value === formikConnect.values.productType
                      )
                    }
                    onChange={(e) =>
                      formikConnect.setFieldValue("productType", e.value)
                    }
                    styles={selectFormStyle}
                  />
                  {formikConnect.touched.productType &&
                    formikConnect.errors.productType && (
                      <div className="mt-2 error-msg">
                        <div className="">
                          {formikConnect.errors.productType}
                        </div>
                      </div>
                    )}
                </div>
                <div className="w-full flex flex-col">
                  <label
                    htmlFor=""
                    className="w-full form-input-label mb-4 required"
                  >
                    Message
                  </label>
                  <textarea
                    placeholder="Enter message"
                    type="text"
                    className="w-full form-input"
                    id="message"
                    value={formikConnect.values.message}
                    onChange={formikConnect.handleChange}
                    rows={3}
                  />
                  {formikConnect.touched.message &&
                    formikConnect.errors.message && (
                      <div className="mt-4 error-msg">
                        <div className="">{formikConnect.errors.message}</div>
                      </div>
                    )}
                </div>
              </div>
              <div className="w-full justify-center gap-5 flex">
                <button
                  type="submit"
                  className="btn-submit"
                  disabled={loadingConnect}
                >
                  {!loadingConnect && <>Submit</>}
                  {loadingConnect && (
                    <div className="flex items-center gap-3">
                      <span className="" style={{ display: "block" }}>
                        Please wait...{" "}
                      </span>
                      <ClipLoader
                        color={"#ffffff"}
                        loading={loadingConnect}
                        size={20}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    </div>
                  )}
                </button>
              </div>
            </form>
          </div>
          <div className="w-full faqs">
            <div className="w-full">
              <h1 className="hanson text-center mb-[1%] ap6-h1">FAQ’s</h1>
              <img
                className="mb-[2%] mx-auto"
                src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
                alt=""
              />
            </div>
            <div className="w-full md:w-[90%] mx-auto flex flex-col gap-5 mb-[5%] faqs">
              {faqsList.map((data, index) => (
                <div
                  key={index}
                  className={
                    isOpen(index) ? "p-[2%] faqs-box-active" : "p-[2%] faqs-box"
                  }
                >
                  <button
                    onClick={() => toggleAccordion(index)}
                    className="flex w-full !text-start justify-between"
                  >
                    <span>{data.question}</span>
                    {isOpen(index) ? (
                      <BiMinus className="faqs-minus" />
                    ) : (
                      <BsPlusLg className="faqs-plus" />
                    )}
                  </button>
                  {isOpen(index) && (
                    <div className="px-4 pb-2 pt-4 text-sm text-gray-500">
                      <p
                        className=""
                        dangerouslySetInnerHTML={{ __html: data.answer }}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReadyReferenceTwo;
